<div class="toasts" *ngIf="data">
  <div class="toast"
    [ngClass]="{'toast-info':toast.type == 'info', 'toast-warn':toast.type == 'warn','toast-error':toast.type == 'error'}"
    [@toastAnimation]
    *ngFor="let toast of data">
    <div class="message" [innerHTML]="toast.message"></div>
    <button mat-button (click)="actionCalled(toast)">
      {{toast.action}}
    </button>
  </div>
</div>
